import {
  getStoredToken,
  sessionChecker,
  sessionCloser,
} from '../../../services/user/SessionChecker';
import { config } from '../../../config';
import { parseFetchError } from '../../../utils/http';
import { appConfig } from 'config/app';
import { sendMultiPartRequest } from 'services/base/sendRequest';

const home = data => {
  const token = getStoredToken();
  delete data.copyArea;

  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.conciliationAdmin.prefix +
          appConfig.api_routes.modules.conciliationAdmin.services.home;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const exportConciliationRequests = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.conciliationAdmin.prefix +
          appConfig.api_routes.modules.conciliationAdmin.services.export;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/xls',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });

        sessionChecker(res);

        const blob = await res.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Solicitudes-de-conciliación.xlsx`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
        resolve({
          respCode: 0,
          message: 'success',
        });
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const editConciliationRequest = id => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.conciliationAdmin.prefix +
          appConfig.api_routes.modules.conciliationAdmin.services.view;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({ id }),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const updateConciliationRequest = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.conciliationAdmin.prefix +
          appConfig.api_routes.modules.conciliationAdmin.services.update;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const deleteConciliationRequest = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.conciliationAdmin.prefix +
          appConfig.api_routes.modules.conciliationAdmin.services.delete;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const assessment = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliationAdmin.prefix +
    appConfig.api_routes.modules.conciliationAdmin.services.assessment;

  let formData = new FormData();

  formData.append(
    'viable',
    JSON.stringify({ on: data.viable.on, date: new Date() }),
  );
  formData.append('id', data.id);
  formData.append('matter', JSON.stringify(data.matter));

  if (!data.viable.on) {
    formData.append('rejectReason', data.rejectReason);
  } else {
    formData.append('docsRequired', data.docsRequired);
    formData.append('cost', data.cost);

    if (data.actsInstructions) {
      formData.append('actsInstructions', data.actsInstructions);
    }
    if (data.actsAnnotations) {
      formData.append('actsAnnotations', data.actsAnnotations);
    }
    if (data.claimsInstructions) {
      formData.append('claimsInstructions', data.claimsInstructions);
    }
    if (data.claimsAnnotations) {
      formData.append('claimsAnnotations', data.claimsAnnotations);
    }
  }

  return sendMultiPartRequest(serviceUrl, formData);
};

const postpone = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliationAdmin.prefix +
    appConfig.api_routes.modules.conciliationAdmin.services.postpone;

  let formData = new FormData();

  formData.append(
    'viable',
    JSON.stringify({ on: data.viable.on, date: new Date() }),
  );
  formData.append('id', data.id);
  formData.append('matter', JSON.stringify(data.matter));

  if (data.actsInstructions) {
    formData.append('actsInstructions', data.actsInstructions);
  }
  if (data.actsAnnotations) {
    formData.append('actsAnnotations', data.actsAnnotations);
  }
  if (data.claimsInstructions) {
    formData.append('claimsInstructions', data.claimsInstructions);
  }
  if (data.claimsAnnotations) {
    formData.append('claimsAnnotations', data.claimsAnnotations);
  }

  if (data.globalInstructions) {
    formData.append('globalInstructions', data.globalInstructions);
  }

  return sendMultiPartRequest(serviceUrl, formData);
};

const approval = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliationAdmin.prefix +
    appConfig.api_routes.modules.conciliationAdmin.services.approval;

  let formData = new FormData();

  formData.append('id', data.id);
  formData.append('radicationNumber', data.radicationNumber);

  return sendMultiPartRequest(serviceUrl, formData);
};

const publishResults = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.conciliationAdmin.prefix +
    appConfig.api_routes.modules.conciliationAdmin.services.publishResults;

  let formData = new FormData();

  formData.append('id', data.id);

  if (data.conciliationAct) {
    formData.append('conciliationAct', data.conciliationAct);
  }

  if (data.constancyImpossibility) {
    formData.append('constancyImpossibility', data.constancyImpossibility);
  }

  if (data.audienceVideoLink) {
    formData.append('audienceVideoLink', data.audienceVideoLink);
  }
  if (data.audienceVideoDescription) {
    formData.append('audienceVideoDescription', data.audienceVideoDescription);
  }

  return sendMultiPartRequest(serviceUrl, formData);
};

export {
  home,
  exportConciliationRequests,
  editConciliationRequest,
  updateConciliationRequest,
  deleteConciliationRequest,
  assessment,
  postpone,
  approval,
  publishResults,
};
